// extracted by mini-css-extract-plugin
module.exports = {"FeaturedCta":"az_fRb","Compact":"az_gRb","Text":"az_hRb"};